import { Box, Button, Modal, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { cancelStyle } from "./cancelModalStyle";

export function CancelModel({ handleModalClose, message }: { handleModalClose: () => void, message: string, }) {
    const [open, setOpen] = useState(false);
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>

            <Button onClick={handleOpen} sx={{ color: '#EB5757' }}>
                <Typography>Cancel</Typography>
            </Button>
            <Modal
                open={open}
                onClose={handleClose}

            >
                <Box sx={{ ...cancelStyle, width: 200 }} mt={10} textAlign={'center'}>
                    <Stack spacing={2} alignItems='center' justifyContent={'center'}>
                        <Typography component='div' variant='h5'  >Go Back?</Typography>
                        <Typography variant='body2' component='span' sx={{ marginTop: '10px' }}>{message}</Typography>
                        <Stack direction={'row'} gap={2} >
                            <Button onClick={handleModalClose}>CANCEL AND GO BACK</Button>
                            <Button onClick={handleClose} variant='contained' color='secondary'>KEEP EDITING</Button>
                        </Stack>
                    </Stack>
                </Box>
            </Modal>
        </>
    );
}